import { useInvalidateFlatsGrid } from '../../../../queries/useFlatsGrid';

export const useChangeLifeCycleSuccess = (flatsGridKey) => {
  const invalidateFlatsGrid = useInvalidateFlatsGrid(flatsGridKey);

  return () => {
    invalidateFlatsGrid();
  };
};
